import React, { useState, useRef, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import TextEditor from "../../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";

import {
  Container,
  Content,
  Title,
  Field,
  Label,
  ActionButtonWrapper,
} from "./styles";
import { Container as SemanticContainer, Segment } from "semantic-ui-react";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { SemanticTable } from "../listar/styles";
import Back from "../Back";

const ListarDetalhes = props => {
  const [segmentQuestions, setSegmentQuestions] = useState([]);
  const [faqSegment, setFaqSegment] = useState([]);

  const id = props.match.params.id;
  const description = useRef("");

  useEffect(() => {
    loadAuth();
    loadFaq();
    loadFaqBySegments();
  }, [faqSegment]);

  const loadAuth = async () => {
    if (!isAuthAdmin("banner\\/faq")) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadFaq = async () => {
    await api
      .get(`/faq-categorias`)
      .then(res => {
        setFaqSegment(res.data);
      })
      .catch(err => {
        swal("Não foi possível carregar as categorias de tipo", err, "error");
      });
  };

  const loadFaqBySegments = async () => {
    await api
      .get(`/faqs-by-segment/${id}`)
      .then(res => {
        setSegmentQuestions(res.data);
      })
      .catch(err => {
        swal("Não foi possível carregar as categorias de tipo", err, "error");
      });
  };

  const removeFaq = useCallback(
    id => {
      swal("Remoção de FAQ", "Você tem certeza que quer remover ?", "").then(
        res => {
          if (res) {
            api.delete(`/admin/faq/${id}`).then(async res => {
              let logs = {
                local: "banner/faq",
                texto: `deletou a FAQ de id=${id}`,
              };
              await api.post("system_logs", { acao: JSON.stringify(logs) });
              const newFaqs = [...faqs].filter(faq => faq.id !== id);
              setFaqs(newFaqs);
            });
          }
        }
      );
    },
    [faqSegment]
  );

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back actualPage={`FAQs sobre ${faqSegment[id - 1]?.segmento}`} />
          <Title>{faqSegment[id - 1]?.segmento}</Title>
          <Link to="/admin/faq/criar" title={`Criar FAQs`}>
            <Button>Criar FAQ</Button>
          </Link>
          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Pergunta</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Resposta</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            {segmentQuestions.length > 0 ? (
              <SemanticTable.Body>
                {segmentQuestions.map((faq, index) => (
                  <SemanticTable.Row key={index}>
                    <SemanticTable.Cell>{faq.id}</SemanticTable.Cell>
                    <SemanticTable.Cell>{faq.pergunta}</SemanticTable.Cell>
                    <SemanticTable.Cell>{faq.resposta}</SemanticTable.Cell>
                    <SemanticTable.Cell>
                      <ActionButtonWrapper>
                        <Button
                          icon="edit icon"
                          color="orange"
                          onClick={() =>
                            window.open(`/admin/faq/edit/${faq.id}`)
                          }
                          title="Editar Segmento"
                        />

                        <Button
                          icon="trash icon"
                          color="grey"
                          onClick={() => removeFaq(faq.id)}
                          title="Remover FAQ"
                        />
                      </ActionButtonWrapper>
                    </SemanticTable.Cell>
                  </SemanticTable.Row>
                ))}
              </SemanticTable.Body>
            ) : (
              <h3>Nenhuma FAQ encontrada</h3>
            )}
          </SemanticTable>
        </Content>
      </Container>
      <SemanticContainer>
        <Segment>
          Grupo Voitto <i class="copyright outline icon"></i>
          {new Date().getFullYear()}
        </Segment>
      </SemanticContainer>
    </>
  );
};

export default withRouter(ListarDetalhes);
